import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import combinePlayerChoices from '../../objects/CommonUse/combine_player_choices';
import ArchiveGameList from './archive_game_list';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';

class SelectGameModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         gameHelp: false,
         archivedGameLoaded: false,
         loadHomeChoiceData: false,
         loadCarChoiceData: false,
         loadJobChoiceData: false,
         environment: Config.dataURL.currentEnv,
         headers: setHeadersForFetch(),
         subProcess: "selectGameModal",
         errorsFound: false,
         waitState: false,
         submitButton: false,
    };    
    this.gameChoiceArr = [];
  }
  
setGameIdArr(){
    this.gameIdArr = [];
    this.gameChoiceArr = [];
    for (let i=0; i<this.gameData.length; i++){
          this.gameIdArr.push(this.gameData[i]._id);
          let gameChoiceObj = {gameID:this.gameData[i].gameID, jobID:this.gameData[i].gameJobId,
            homeID:this.gameData[i].gameHomeId, carID:this.gameData[i].gameCarId};
          this.gameChoiceArr.push(gameChoiceObj);
    }
}
  
createGameChoicesArr(){
    this.gameChoiceArr = [];  
    let counter = 0;
    for (let i=0; i<this.allChoicesArr.length; i++){
        let gameDataObj = this.gameData.find(elem => elem.gameID === this.allChoicesArr[i].gameID);
        if (gameDataObj){
            counter += 1;
            const choiceItem = this.allChoicesArr[i];
            const homeChoice = choiceItem.homeName + "-" + choiceItem.homeBedrooms + " bedroom(s)";
            const gameChoiceObj = {gameNbr: counter, dateArchived: gameDataObj.dateArchived,
                gameCashAmt: gameDataObj.cashAmt, jobChoice: choiceItem.jobName, 
                homeChoice: homeChoice, carChoice: choiceItem.carSizeName
                }
                this.gameChoiceArr.push(gameChoiceObj);
        }
    }
}
 
render() { 
        if(this.state.loadJobChoiceData === true && this.state.loadHomeChoiceData === true &&
            this.state.loadCarChoiceData === true){
                this.setGameIdArr();
                this.allChoicesArr = combinePlayerChoices(this.gameChoiceArr, this.jobChoiceData,
                    this.homeChoiceData, this.carChoiceData);
                this.createGameChoicesArr();
                this.waitState = false;
                this.loadGameChoicesData = true
        }
        if (this.loadGameChoicesData === true){
            this.previousGameInfo = this.gameChoiceArr.map((archiveGames, index) =>
              <ArchiveGameList  key={index}  gameInfo={archiveGames} 
              />
              );
        }
  return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg"
            animation={false}>
          <Modal.Header className="gameModalHdrFtrBackground" closeButton>
            <Modal.Title>Restore a Previous Game</Modal.Title> 
          </Modal.Header>
          <Modal.Body >
                {this.waitState  ?
                    <WaitTimeSpinner />
                :
                    <span>
                        <div className="mr-2 ml-2">
                            <div>
                                Select the game that you would like to restore from the list below.
                            </div>
                        </div>
                        <table className="table table-hover table-no-space mt-4">
                            <tbody>
                                <tr>
                                    <th className="text-center">Game Nbr</th>
                                    <th className="text-center">Date Archived</th>
                                    <th className="text-center">Ending Cash Amt</th>
                                    <th className="text-center">Job Choice</th>
                                    <th className="text-center">Home Choice</th>
                                    <th className="text-center">Car Choice</th>
                                </tr>
                                 {this.previousGameInfo}
                            </tbody>
                        </table>
                    </span>
                }
            
          </Modal.Body>
          <Modal.Footer className="gameModalHdrFtrBackground text-right">
                <div className="mt-2">
                    <label className="font-weight-bold" htmlFor="gameNbr">
                            Select Game Nbr to Be Restored:&nbsp;&nbsp;</label>
                    <input type="text" className="col-small" id="gameNbr" name="gameNbr"
                        onChange={() => this.processGameChoice()}></input> 
                    <div className="text-danger">
                          &nbsp;{this.errorMsg}
                    </div>
                    {this.state.submitButton   ?
                        <div className="text-right">
                            <Button  variant="primary" onClick={() => this.gameChoiceSubmitted()}>
                                Confirm Restore
                            </Button>
                        </div>
                    :
                        null
                    }
                </div>
          </Modal.Footer>
          </Modal>  
    </>
  }

componentDidMount(){
   this._isMounted = true;
   this.waitState = true;
   this.setState({waitState: true});
   this.loadArchivedGames();
}

processGameChoice(){
    this.gameNbr = document.getElementById("gameNbr").value;
    if (isNaN(this.gameNbr) || +this.gameNbr < 1 || +this.gameNbr > this.gameData.length){
        this.errorMsg = "Game Number must be a number from 1 to " + this.gameData.length;
        this.setState({errorsFound: !this.state.errorsFound});
    }else{
        this.setState({submitButton: true});
    }    
}

gameChoiceSubmitted(){
    const gameIndx = this.gameNbr - 1;
    const gameID = this.gameData[gameIndx].gameID;
    this.props.onGameSelected(gameID);
}

loadArchivedGames(){
  const funcName = "archivedGameData";
        const urlParm = "?maxNbrGames=5&rqstType=MaxNbrGames";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameData = output.body;
                        this.loadGameChoiceData();
                        if (this._isMounted === true){
                            this.setState({archivedGameLoaded: true});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

loadGameChoiceData(){
    this.loadJobChoices();
    this.loadHomeChoices();
    this.loadCarChoices();
}

loadJobChoices(){
    let jobIdArr=[];
    for (let i=0; i<this.gameData.length; i++){
          jobIdArr.push(this.gameData[i].gameJobId);
    }
    const jobIdParm = jobIdArr.join(',');
    const funcName = "jobInfo";
    const urlParm = "?jobId=" + jobIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.jobChoiceData = output.body;
                    this.setState({loadJobChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }

loadHomeChoices(){
    let homeIdArr=[];
    for (let i=0; i<this.gameData.length; i++){
          homeIdArr.push(this.gameData[i].gameHomeId);
    }
    const homeIdParm = homeIdArr.join(',');
    const funcName = "homeInfo";
    const urlParm = "?homeId=" + homeIdParm + "&returnType=Multiple";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.homeChoiceData = output.body;
                    this.setState({loadHomeChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }
    
loadCarChoices(){
    let carIdArr=[];
    for (let i=0; i<this.gameData.length; i++){
          carIdArr.push(this.gameData[i].gameCarId);
    }
    const carIdParm = carIdArr.join(',')
    const funcName = "carInfo";
    const urlParm = "?carId=" + carIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.carChoiceData = output.body;
                    this.setState({loadCarChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}


 
}
export default SelectGameModal;